import { Button } from "../../../../core/Button.js";
import { Text } from "../../../../core/Text.js";
import { Amount } from "../../../../domain/Amount.js";
import type { InventorySelectionContent } from "../../inventoryContent.js";

/**
 * The bar that floats over the grid while units are picked: how
 * many, what they're worth, Clear, and Sell back. It sticks to the bottom of the view, above the
 * phone's tab bar, so a long grid never scrolls it away.
 */
export function InventorySelectionBar({
  summary,
  totalCents,
  totalLabel,
  clear,
  sell,
}: InventorySelectionContent) {
  return (
    // Above the phone's floating tab bar (bottom-5, h-16), and near the edge from md, where it's gone.
    <div className="sticky bottom-24 z-10 mx-auto w-full max-w-2xl md:bottom-6">
      <div className="glass flex flex-wrap items-center justify-between gap-3 rounded-2xl px-4 py-3 shadow-[var(--theme-surface-shadow)] md:px-5">
        <div aria-live="polite" className="flex min-w-0 flex-col">
          <Text variant="body-b1-strong" tone="primary">
            {summary}
          </Text>
          <span className="flex items-center gap-1 font-body text-body-b3 text-text-secondary">
            {totalLabel} <Amount cents={totalCents} size="meta" />
          </span>
        </div>
        <div className="flex flex-1 items-center justify-end gap-2 sm:flex-none">
          <Button variant="ghost" size="sm" onClick={clear.onClick}>
            {clear.label}
          </Button>
          <Button variant="primary" onClick={sell.onClick} className="max-sm:flex-1">
            {sell.label}
          </Button>
        </div>
      </div>
    </div>
  );
}
